import script from "./Addsp.vue?vue&type=script&setup=true&lang=js"
export * from "./Addsp.vue?vue&type=script&setup=true&lang=js"

import "./Addsp.vue?vue&type=style&index=0&id=19f7c174&lang=css"

const __exports__ = script;

export default __exports__